<div *ngIf="!displayMobileView" class="content-table-pointer">
  <ion-row class="content" routerLink="./edit/{{ row.id }}">
    <ion-col size="2">
      <ion-item lines="none" class="building-view__logo">
        <ion-avatar slot="start">
          <img
            *ngIf="row.image"
            [src]="
              row.image.thumbnail ? row.image.thumbnail : row.image.filePath
            "
          />

          <img
            *ngIf="!row.image"
            src="../../../assets/icons/company-plug.svg"
          />
        </ion-avatar>
      </ion-item>
    </ion-col>
    <ion-col size="3">
      {{ row.name }}
    </ion-col>

    <ion-col size="2">{{ row.street }}</ion-col>
    <ion-col size="2">{{ row.city }}</ion-col>
    <ion-col size="3">
      {{ row.description }}
    </ion-col>
  </ion-row>
</div>

<ion-card
  *ngIf="displayMobileView"
  class="content-card-noborder"
  routerLink="./edit/{{ row.id }}"
>
  <ion-card-content class="invitation-mobile-header">
    <ion-grid class="no-padding-grid">
      <ion-row>
        <ion-col>
          <ion-text class="inv-info">{{ row.name }}</ion-text>
        </ion-col>
      </ion-row>
    </ion-grid>
    <div class="line-divider"></div>
  </ion-card-content>

  <ion-card-header>
    <ion-card-title>
      <ion-grid class="building-view">
        <ion-row>
          <ion-col size="9" class="building-view__adress">
            <ion-text>
              {{ row.street }}
              <br />
              {{ row.postCode }} {{ row.city }}
            </ion-text>
          </ion-col>
          <ion-col size="3">
            <ion-avatar class="building-view__avatar">
              <img
                [src]="
                  row.image
                    ? row.image.filePath
                    : '../../../assets/icons/company-plug.svg'
                "
              />
            </ion-avatar>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-card-title>
    <ion-card-subtitle class="building-view__description">
      {{ row.description }}
    </ion-card-subtitle>
  </ion-card-header>
</ion-card>
